import { Modal } from '@77sol-ui/molecules'
import styled from 'styled-components'

export const ModalWrapper = styled(Modal.Wrapper)`
  @media (max-width: 768px) {
    max-height: 75vh !important;
  }
`
